<div class="am-flex-align b-blue hover-active toggler-box small" (click)="toggle()">
  <div class="bg-blue toggler" [class.right]="currentValue === rightValue"></div>
</div>
